import React, { useState } from 'react';
import get from 'lodash/get';
import { Rate } from 'antd';
import {
  HeartFilled,
  HeartOutlined,
  StarFilled,
  StarOutlined,
} from '@ant-design/icons';

export const icons = {
  StarFilled: <StarFilled />,
  StarOutlined: <StarOutlined />,
  HeartFilled: <HeartFilled />,
  HeartOutlined: <HeartOutlined />,
};

const getArray = (min, max) => {
  let numeric = [];

  for (let i = 0; i <= max - min; i++) {
    numeric[i] = {score: i + min};
  }

  return numeric;
};

const colors = {
  promotor:'#4bc3b4',
  detractor:'#c32420',
  neutral:'#eac462',
  notApply: 'gray'
};

const degradedColors = [
  {color: '#b72124'},
  {color: '#d62127'},
  {color: '#ef5222'},
  {color: '#f56f21'},
  {color: '#faa822'},
  {color: '#ffca27'},
  {color: '#ecdb10'},
  {color: '#dedd37'},
  {color: '#c5d92e'},
  {color: '#afd135'},
  {color: '#64b54c'},
];

const QuestionScoreNumeric = ({ question, value, setScore }) => {
  const min = get(question, 'metadata.settings.score.min', 0);
  const max = get(question, 'metadata.settings.score.max', 10);

  const allowScoreNa=get(question, 'metadata.settings.allowScoreNA');

  const [numericValue, setNumericValue] = useState(
    get(value,'score')?((get(value,'score') - 1) * (max - min)) / 9 + min:get(value,'dirty')?'N/A':null
  );

  const numeric = get(question, 'metadata.settings.allowScoreNA')
    ? [...getArray(min, max), {score: 'N/A'}]
    : getArray(min, max);

  const setNumericScore = (voteValue, min, max) => {
    if(!question.isNotDisable(value)) return;
    if (voteValue === 'N/A') {
      setScore(null);
      setNumericValue(voteValue);
    } else {
      setNumericValue(voteValue);
      const score = ((voteValue - min) * 9) / (max - min) + 1;
      setScore(score);
    }
  };

  function getTypeScore(value){
    const score = ((value - min) * 9) / (max - min) + 1;
    if(score>=9){
      return 'promotor';
    } else if(score<7){
      return 'detractor';
    } else if(value === 'N/A') {
      return 'notApply'
    } else {
      return 'neutral'
    }
  }

  const layout = get(question, 'metadata.settings.score.layout');
  const withColor = get(question, 'metadata.settings.score.withColor',false);
  const customIcon = get(
    question,
    'metadata.settings.score.icon.name',
    'StarFilled'
  );
  const customIconColor = get(question, 'metadata.settings.score.icon.color');
  const customIconSize = get(question, 'metadata.settings.score.icon.fontSize');
  const labelsLayout = get(
    question,
    'metadata.settings.score.labelsLayout',
    'down'
  );
  const degraded = get(question, 'metadata.settings.score.degraded',false);

  const completNumeric = numeric.map((values, index) => {

    return {
      background: index === numeric.length -1 && get(question, 'metadata.settings.allowScoreNA') ? 'gray' : degradedColors[index].color,
      score: values === 'N/A' ? null : values.score
    }
  });

  const { worst, best } = get(question, 'metadata.settings.score', []);

  const labels = () => {
    return (
      <div className={'label-score'}>
        <div className={'description-score-worst'}>{worst}</div>
        <div className={'description-score-best'}>{best}</div>
      </div>
    );
  };
  return (
    <div style={{ width: '90%', margin: 'auto' }}>
      {labelsLayout === 'up' && labels()}
      {layout === 'custom' ? (
        <Rate
          character={icons[customIcon] ? icons[customIcon] : icons.StarFilled}
          style={{ color: customIconColor, fontSize: customIconSize }}
          allowClear={false}
          count={max}
          value={numericValue}
          onChange={(value) => setNumericScore(value, min, max)}
        />
      ) : layout === 'button' ? (
        <ul className={`numericStyle ${layout}`}>
          {completNumeric.map((values, index) => {
            return (
              <li
                style={
                  layout && index === 0
                    ? {
                        color: degraded ? ((numericValue === values.score) ? values.background : 'white') : ((numericValue === values.score) && layout && withColor?colors[getTypeScore(values.score)]:withColor?'white':'black'),
                        background: degraded ? ((numericValue === values.score) ? 'white' : values.background) : ((numericValue === values.score) && layout && withColor?'white':withColor? colors[getTypeScore(values.score)]:'white'),
                        borderColor:withColor?'rgb(255 255 255)':'#595959',
                        border: 'solid 1px',
                        borderRadius: '5px 0px 0px 5px',
                        borderRightWidth: '0.5px',
                      }
                    : layout && (index === (allowScoreNa?max+1:max) - min  )
                    ? {
                        color: degraded ? ((numericValue === values.score) ? values.background : 'white') : ((numericValue === values.score) && layout && withColor?colors[getTypeScore(values.score)]:withColor?'white':'black'),
                        background: degraded ? ((numericValue === values.score) ? 'white' : values.background) : ((numericValue === values.score) && layout && withColor?'white':withColor?colors[getTypeScore(values.score)]:'white'),
                        borderColor:withColor?'rgb(255 255 255)':'#595959',
                        border: 'solid 1px',
                        borderRadius: '0px 5px 5px 0px',
                        borderLeftWidth: '0.5px',
                        paddingLeft: '3px',
                        paddingRight: '3px'

                      }
                    : layout
                    ? {
                        color: degraded ? ((numericValue === values.score) ? values.background : 'white') : ((numericValue === values.score) && layout && withColor?colors[getTypeScore(values.score)]:withColor?'white':'black'),
                        background: degraded ? ((numericValue === values.score) ? 'white' : values.background) : ((numericValue === values.score) && layout && withColor?'white':withColor?colors[getTypeScore(values.score)]:'white'),
                        borderColor:withColor?'rgb(255 255 255)':'#595959',
                        border: 'solid 1px',
                        borderLeftWidth: '0.5px',
                        borderRightWidth: '0.5px',
                        borderRadius: '0px 0px 0px 0px',
                      }
                    : null
                }
                className={
                  value && !get(value,'dirty') && numericValue!=='N/A'
                    ? 'estadoInicial'
                    : value &&
                      value.pregunta === question.id &&
                      (numericValue === values.score)  &&
                      !layout
                    ? 'select'
                    : (numericValue === values.score) && layout && !withColor
                    ? 'select-bordered'
                    : 'sinselect'
                }
                key={values.score}
                data-testid={question.id+''+values.score}
                onClick={() => setNumericScore(values.score, min, max)}
              >
                {values.score === null ? 'N/A' : values.score}
              </li>
            );
          })}
        </ul>
      ) : (
        <ul className={`numericStyle`}>
          {completNumeric.map((values, index) => {
            return (
              <li
                className={
                  value && !get(value,'dirty')
                    ? 'estadoInicial'
                    : value &&
                      value.pregunta === question.id &&
                      numericValue === values.score
                    ? 'select'
                    : numericValue === values.score
                    ? 'select-bordered'
                    : 'sinselect'
                }
                key={values.score}
                data-testid={question.id+''+values.score}
                onClick={() => setNumericScore(values.score, min, max)}
              >
                {values.score}

                {value &&
                value.pregunta === question.id &&
                numericValue === values.score ? (
                  <i className={'smile21-radio-checked'} />
                ) : (
                  <i className={'smile21-radio-unchecked'} />
                )}
              </li>
            );
          })}
        </ul>
      )}

      {labelsLayout === 'down' && labels()}
    </div>
  );
};

export default QuestionScoreNumeric;
